import type { AxiosContextProps } from '@flex-packages/remote-hooks';
import { AxiosContext } from '@flex-packages/remote-hooks';
import getConfig from 'next/config';
import { useState, type PropsWithChildren } from 'react';

import { getAxiosInstance } from './logics';

interface Props {
  locale: string;
}
function AxiosContextProvider({ locale, children }: PropsWithChildren<Props>) {
  const [instances] = useState<AxiosContextProps['instances']>(() => ({
    json: getAxiosInstance({
      apiEndpoint: getConfig().publicRuntimeConfig.API_ENDPOINT,
      locale,
    }),
    blob: getAxiosInstance({
      apiEndpoint: getConfig().publicRuntimeConfig.API_ENDPOINT,
      locale,
      requestConfig: { responseType: 'blob' },
    }),
  }));

  return (
    <AxiosContext.Provider value={{ instances }}>
      {children}
    </AxiosContext.Provider>
  );
}

export { AxiosContextProvider };
